import useSWR from "swr"

import fetchDeliveryOptions from "@secureo/common/utils/commerceTools/graphql/queries/fetchDeliveryOptions"
import { DeliveryOption } from "@secureo/common/typings/Product"

const useDeliveryOptions = (
	accessToken: string,
	deliveryOptionSkus: string[],
	language: string,
) => {
	const { data: deliveryOptions, error } = useSWR(
		accessToken && deliveryOptionSkus?.length > 0
			? [accessToken, deliveryOptionSkus, language]
			: null,
		([accessToken, deliveryOptionSkus, language]) =>
			fetchDeliveryOptions(accessToken, deliveryOptionSkus, language),
		{
			fallbackData: [],
			revalidateOnMount: true,
		},
	)

	const deliveryOptionsBySku = deliveryOptions.reduce(
		(deliveryOptionsBySku, deliveryOption) => {
			const { sku } = deliveryOption
			return {
				...deliveryOptionsBySku,
				[sku]: deliveryOption,
			}
		},
		{} as {
			[sku: string]: DeliveryOption
		},
	)

	return { deliveryOptionsBySku, error }
}

export default useDeliveryOptions
